import React from "react";

const isPdf = (url) => typeof url === "string" && url.toLowerCase().includes(".pdf");

export default function MediaModal({ show, setShow, size = "md", url }) {
  if (!show) return null;

  const close = () => setShow(false);

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60">
      <div
        className={`bg-white rounded-lg shadow-lg w-full ${
          size === "md" ? "max-w-2xl" : size === "lg" ? "max-w-4xl" : "max-w-6xl"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-2 border-b">
          <div className="font-semibold text-sm">Preview</div>
          <button
            onClick={close}
            className="px-3 py-1 text-sm rounded bg-gray-200 hover:bg-gray-300"
          >
            Close
          </button>
        </div>

        <div className="p-3">
          <div className="h-[70vh] w-full overflow-auto rounded border bg-gray-50">
            {url ? (
              isPdf(url) ? (
                // PDF viewer (scrollable)
                // Use both <object> and <iframe> as a fallback chain
                <object data={url} type="application/pdf" className="w-full h-full">
                  <iframe title="pdf-view" src={url} className="w-full h-full" />
                </object>
              ) : (
                // Image viewer
                <img
                  src={url}
                  alt="product-image"
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              )
            ) : (
              <div className="w-full h-full flex items-center justify-center text-sm text-gray-500">
                No preview available
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}